import { render } from "./SecurityGlobalFooter.vue?vue&type=template&id=37b7cfb8&scoped=true"
import script from "./SecurityGlobalFooter.vue?vue&type=script&lang=js"
export * from "./SecurityGlobalFooter.vue?vue&type=script&lang=js"

import "./SecurityGlobalFooter.vue?vue&type=style&index=0&id=37b7cfb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b7cfb8"]])

export default __exports__